<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    :labelText="labelText"
    id="selectAdvogado"
    placeholder="Selecione o(s) Advogado(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>

<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import AdvogadoRepository from '@/shared/http/repositories/configurations/advogado.js'

export default {
  name: 'NxSelectAjuizamentoAdvogado',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    labelText: {
      type: String,
      default: 'Advogado:'
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadAdvogados()
  },
  methods: {
    onLoadAdvogados () {
      AdvogadoRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({ value: x.id, text: x.nome }))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Advogados', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectAjuizamentoAdvogado.vue